import { TFunction } from 'i18next';
import { logWarning } from '../../../modules/shared';

// Some types are not known, these have been indicated as H5P.Undefined

export enum QuestionType {
  FILL_IN_THE_BLANKS = 'H5P.Blanks',
  MULTIPLE_CHOICE = 'H5P.MultiChoice',
  DRAG_THE_WORDS = 'H5P.DragText',
  TRUE_FALSE = 'H5P.TrueFalse',
  MULTIPLE_ANSWER = 'H5P.Undefined',
  MARK_THE_WORDS = 'H5P.MarkTheWords',
  DRAG_AND_DROP = 'H5P.DragQuestion',
  QUIZ = 'H5P.QuestionSet',
  COLUMN = 'H5P.Column',
  ESSAY = 'H5P.Essay',
  IMAGE_SEQUENCING = 'H5P.ImageSequencing',
  DIALOG_CARDS = 'H5P.Dialogcards',
  DICTATION = 'H5P.Dictation',
  AUDIO = 'H5P.Audio',
  AUDIO_RECORDER = 'H5P.AudioRecorder',
  CHART = 'H5P.Chart',
  COLLAGE = 'H5P.Collage',
  DOCUMENTATION_TOOL = 'H5P.DocumentationTool',
  FIND_THE_MULTIPLE_HOTSPOTS = 'H5P.ImageMultipleHotspotQuestion',
  FIND_THE_HOTSPOTS = 'H5P.ImageHotspotQuestion',
  FIND_THE_WORDS = 'H5P.FindTheWords',
  FLASHCARDS = 'H5P.Flashcards',
  GUESS_THE_ANSWER = 'H5P.GuessTheAnswer',
  IFRAME_EMBED = 'H5P.IFrameEmbed',
  IMAGE_HOTSPOTS = 'H5P.ImageHotspots',
  IMAGE_JUXTAPOSITION = 'H5P.ImageJuxtaposition',
  IMAGE_PAIRING = 'H5P.ImagePair',
  IMAGE_SLIDER = 'H5P.ImageSlider',
  IMPRESSIVE_PRESENTATION = 'H5P.Undefined',
  INTERACTIVE_BOOK = 'H5P.InteractiveBook',
  KEW_AR_CODE = 'H5P.KewArCode',
  MEMORY_GAME = 'H5P.MemoryGame',
  PERSONALITY_QUIZ = 'H5P.PersonalityQuiz',
  QUESTIONNAIRE = 'H5P.Questionnaire',
  SINGLE_CHOICE_SET = 'H5P.SingleChoiceSet',
  SPEAK_THE_WORDS = 'H5P.SpeakTheWords',
  SPEAK_THE_WORDS_SET = 'H5P.SpeakTheWordsSet',
  SUMMARY = 'H5P.Summary',
  TIMELINE = 'H5P.Timeline',
  INTERACTIVE_VIDEO = 'H5P.InteractiveVideo',
  COURSE_PRESENTATION = 'H5P.CoursePresentation',
  BRANCHING_SCENARIO = 'H5P.BranchingScenario',
  ADVANCED_FILL_IN_THE_BLANKS = 'H5P.Undefined',
  AGAMOTTO = 'H5P.Agamotto',
  ACCORDION = 'H5P.Accordion',
  ADVANCED_TEXT = 'H5P.AdvancedText',
}

export const EMPTY_SCORE_TYPES = [
  QuestionType.ESSAY,
  QuestionType.MEMORY_GAME,
  QuestionType.DOCUMENTATION_TOOL,
  QuestionType.SPEAK_THE_WORDS_SET,
];

export const getMessageByQuestionType = (t: TFunction, questionType?: QuestionType): string => {
  switch (questionType) {
    case QuestionType.COLUMN:
    case QuestionType.FIND_THE_MULTIPLE_HOTSPOTS:
    case QuestionType.FIND_THE_HOTSPOTS:
    case QuestionType.FLASHCARDS:
    case QuestionType.IMAGE_PAIRING:
    case QuestionType.MEMORY_GAME:
    case QuestionType.SINGLE_CHOICE_SET:
    case QuestionType.SUMMARY:
    case QuestionType.COURSE_PRESENTATION:
    case QuestionType.IMAGE_SEQUENCING:
      return t('trajectory.sections.shared.answers.noAnswersForExerciseType');
    case QuestionType.DIALOG_CARDS:
    case QuestionType.AUDIO:
    case QuestionType.AUDIO_RECORDER:
    case QuestionType.CHART:
    case QuestionType.COLLAGE:
    case QuestionType.DOCUMENTATION_TOOL:
    case QuestionType.FIND_THE_WORDS:
    case QuestionType.GUESS_THE_ANSWER:
    case QuestionType.IFRAME_EMBED:
    case QuestionType.IMAGE_HOTSPOTS:
    case QuestionType.IMAGE_JUXTAPOSITION:
    case QuestionType.IMAGE_SLIDER:
    case QuestionType.IMPRESSIVE_PRESENTATION:
    case QuestionType.INTERACTIVE_BOOK:
    case QuestionType.KEW_AR_CODE:
    case QuestionType.PERSONALITY_QUIZ:
    case QuestionType.QUESTIONNAIRE:
    case QuestionType.TIMELINE:
    case QuestionType.INTERACTIVE_VIDEO:
    case QuestionType.BRANCHING_SCENARIO:
    case QuestionType.ADVANCED_FILL_IN_THE_BLANKS:
    case QuestionType.AGAMOTTO:
    case QuestionType.ACCORDION:
      return t('trajectory.sections.shared.answers.noAnswersOrScoresForExerciseType');
    default:
      return t('trajectory.sections.shared.answers.noAnswersOrScoresForExerciseType');
  }
};

export const getQuestionTypeWithoutVersion = (input: string): QuestionType | undefined => {
  const strippedInput = input.split(' ')[0];

  if (Object.values(QuestionType).includes(strippedInput as QuestionType))
    return strippedInput as QuestionType;

  logWarning(`${strippedInput}: Unknown questionType encountered.`);

  return undefined;
};
